import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import urldata from "../../../urldata";

const NewsLetter = (props) => {
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);

  useEffect(() => {
    setLoading(true);

    let url = new URL(urldata + "admin/getNewsLetterList");
    axios({
      method: "get",
      url: url,
      withCredentials: true,
    })
      .then((response) => {
        const list = response.data.data.reverse();
        setList(list);
        setLoading(false);
      })
      .catch((error) => {
        alert("Something Went Wrong");
        setLoading(false);

      });
  }, []);
  return (
    <>
      <MaterialTable
        title="News Letter"
        columns={[
          {
            title: "Date",
            field: "date",
          },
          {
            title: "Time",
            field: "time",
          },

          {
            title: "EmailId",
            field: "emailId",
          },
        ]}
        data={list}
        options={{
          exportButton: true,
          actionsColumnIndex: -1,
        }}
      />
    </>
  );
};

export default NewsLetter;
